import React, { useContext } from 'react';

import { CardListSkeleton } from '@eika-kortbetjening/card-list-panel';
import { ErrorCard } from '@eika/card';

import CardControlContext from '@/context/card-control/CardControlContext';
import { useCard } from '@/react-query/hooks/query/use-card';
import { useCardSpendingLimits } from '@/react-query/hooks/query/use-spending-limits';

import useText from '@hooks/use-text';

import { SpendingLimitCategory } from '../types';
import { DailyLimitEcommerceForm, DailyLimitForm, MonthlyLimitEcommerceForm, MonthlyLimitForm } from './form/Form';
import ProductSpendingLimits from './product-spending-limits/ProductSpendingLimits';
import {
    DailyLimitEcommerceReadOnly,
    DailyLimitReadOnly,
    MonthlyLimitEcommerceReadOnly,
    MonthlyLimitReadOnly,
} from './read-only/ReadOnly';

const CategorySpecific = () => {
    const text = useText();
    const { selectedCategory } = useContext(CardControlContext);
    const { data: card } = useCard();
    const { data: spendingLimits, isLoading, isError } = useCardSpendingLimits();

    if (isError) {
        return <ErrorCard title={text.spendingLimitFetchError} />;
    }

    if (isLoading) {
        return <CardListSkeleton />;
    }

    if (!card || !spendingLimits) {
        return null;
    }

    const { setSpendingLimit } = card.allowedOperations;

    if (selectedCategory === SpendingLimitCategory.DailyLimit) {
        if (setSpendingLimit) {
            return <DailyLimitForm />;
        }

        return <DailyLimitReadOnly />;
    }

    if (selectedCategory === SpendingLimitCategory.MonthlyLimit) {
        if (setSpendingLimit) {
            return <MonthlyLimitForm />;
        }

        return <MonthlyLimitReadOnly />;
    }

    if (selectedCategory === SpendingLimitCategory.DailyLimitEcommerce) {
        if (setSpendingLimit) {
            return <DailyLimitEcommerceForm />;
        }

        return <DailyLimitEcommerceReadOnly />;
    }

    if (selectedCategory === SpendingLimitCategory.MonthlyLimitEcommerce) {
        if (setSpendingLimit) {
            return <MonthlyLimitEcommerceForm />;
        }

        return <MonthlyLimitEcommerceReadOnly />;
    }

    return null;
};

const SelectedCategory = () => {
    const text = useText();
    return (
        <section className="selected-category">
            <div className="spending-limits-amount">
                <h2 className="spending-limits-amount__header">{text.spendingLimitsLabel}</h2>
                <CategorySpecific />
                <aside className="spending-limits-amount__info">
                    <ProductSpendingLimits />
                </aside>
            </div>
        </section>
    );
};

export default SelectedCategory;
